export const bullet = {
  color: "#FDCB6E",
};